import './MyBlockMonthNoData.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { blockType } from '../../constants/myBlockMonth';
import { useMyBlockMonthProvider } from '../../providers/MyBlockMonthProvider';
import { useProfile } from '../../providers/Profile';

const MyBlockMonthNoData = ({ searchDate }) => {
    const { t } = useTranslation();
    const myBlockMonthContext = useMyBlockMonthProvider();
    const profileContext = useProfile();

    const[hrefData,setHrefData] = useState('');
    const profileData = profileContext?.profile?.results;

    const months = [
        { short: 'JAN', long: 'January' },
        { short: 'FEB', long: 'February' },
        { short: 'MAR', long: 'March' },
        { short: 'APR', long: 'April' },
        { short: 'MAY', long: 'May' },
        { short: 'JUN', long: 'June' },
        { short: 'JUL', long: 'July' },
        { short: 'AUG', long: 'August' },
        { short: 'SEP', long: 'September' },
        { short: 'OCT', long: 'October' },
        { short: 'NOV', long: 'November' },
        { short: 'DEC', long: 'December' },
    ];

    useEffect(()=>{
        if(!searchDate)return;

        const nodatadate = searchDate ? `${months[searchDate?.month - 1]?.long} ${searchDate?.year}` : '';
        setHrefData(`mailto:myaccess@aircanada.ca?&subject=Block Month data is not available for ${nodatadate} &body=Hello Team,%20%0D%0AName is ${profileData?.['name']} Emp id is ${profileData?.EmployeeId}, Base Location is ${profileData?.baseLocation} and Equipment is ${profileData?.equipment}`);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[searchDate])
    
    return (
        <div className="c-mbm-no-data">
            <i className="icon-circle-flight no-data__alert-icon-ref" />
            <div className="c-info-text">
                <p> {myBlockMonthContext.myBlockMonthData?.blockList?.BLOCK_TYPE_MNT === blockType.NONEXISTING ? t('myBlockMonth.noEventsMessage2') : t('myBlockMonth.noEvents')}</p>
                <p title="myaccess@aircanada.ca"> 
                    {t('myBlockMonth.noEventsMessage1')} 
                    <span className="info__additional-info-ref">
                        <a className="info__additional-info-ref" href={hrefData}>{t('myBlockMonth.supportTeamLink')}</a>
                    </span>
                </p>
            </div>
        </div>
    );
}

export default MyBlockMonthNoData;
